import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // 1. Déterminer automatiquement la section
    let currentSection = "Erwan Tapparel (Accueil)";

    if (
      location.pathname.startsWith('/cave') || 
      location.pathname.startsWith('/code-qr') || 
      location.pathname.startsWith('/connexion') || 
      location.pathname.startsWith('/administration')
    ) {
      currentSection = "Wine";
    } else if (location.pathname.startsWith('/musique')) {
      currentSection = "Music";
    }

    // 2. Envoyer la vue de page avec le groupe de contenu
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
      content_group: currentSection, // Attribut natif GA4 pour classer la page
    });
  }, [location.pathname]);

  return null;
}